import React, { Fragment } from 'react';
import { Intro, Video } from 'dea-core';
import transcript from '../../assets/videos/DEA_OPW_M01_10.vtt';
// import poster from '../../assets/videos/';

const videoFiles = {
  sources: [
    {
      src:
        'https://operationprevention.com/sites/default/files/SPM_videos/module_1/DEA_OPW_M01_10_V2_ALT.mp4'
    }
  ],
  tracks: [
    {
      src: transcript,
      kind: 'captions',
      label: 'English'
    }
  ],
  poster: ''
};

export default {
  title: 'Carrie’s Story into Opioids',
  path: '/elaborate/opioid-epidemic-is-personal-carrie',
  content: (
    <Fragment>
      <Intro
        title="Carrie’s story into opioids."
        lead="Carrie shares about her upbringing and how she found herself in active addiction…"
        direction={'Select the play button below to begin.'}
      />
      <Video videoFiles={videoFiles} />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/elaborate/OpioidEpidemicIsPersonalCarrie.js